/* unplugin-vue-components disabled */import { render } from "./ActiveStatistics.vue?vue&type=template&id=8eb82630&scoped=true"
import script from "./ActiveStatistics.vue?vue&type=script&lang=js"
export * from "./ActiveStatistics.vue?vue&type=script&lang=js"

import "./ActiveStatistics.vue?vue&type=style&index=0&id=8eb82630&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eb82630"]])

export default __exports__